import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.expiringCoachRenewals');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{tt('title', 'Coach Renewal')}</Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('renewalExpires', 'Renewal Expires')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxRenewalExpires} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('frontlineCoaches', 'Frontline Coaches')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxFrontlineCoaches} />}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('frontlineClients', 'Frontline Clients')}</Text>}
          suffix={<LoadingBox style={styles.loadingBoxFrontlineClients} />}
        />
      </Gutter>
    </View>
  );
};
